import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/pendo/pendo.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 */
export { PendoService } from '@ng/core/pendo/pendo.service';

export const PendoServiceModule = angular.module('acme.common.service.pendo', []).name;
